import { render, staticRenderFns } from "./HasDiningRoom.vue?vue&type=template&id=f577a18a&"
import script from "./HasDiningRoom.vue?vue&type=script&lang=ts&"
export * from "./HasDiningRoom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports